// extracted by mini-css-extract-plugin
export default {"wrap":"MailboxContentPreview_wrap__1dpDO","content":"MailboxContentPreview_content__43wHe","blueAction":"MailboxContentPreview_blueAction__N45gW"};